export let render_60_arr = [
    {
        name: 'default',
        param: 'default',
        src: '/assets/render_hack_60_50.jpg',
    },
    {
        name: 'type#01',
        param: 'style1',
        src: '/assets/render_style1_60_50.jpg',
    },
    {
        name: 'type#02',
        param: 'style2',
        src: '/assets/render_style2_60_50.jpg',
    },
    {
        name: 'type#03',
        param: 'style3',
        src: '/assets/render_style3_60_50.jpg',
    },
    {
        name: 'type#04',
        param: 'style4',
        src: '/assets/render_style4_60_50.jpg',
    },
    {
        name: 'type#05',
        param: 'style5',
        src: '/assets/render_style5_60_50.jpg',
    }];

export let render_200_arr = [
    {
        name: 'default',
        param: 'default',
        src: '/assets/render_hack_200_150.jpg',
    },
    {
        name: 'type#01',
        param: 'style1',
        src: '/assets/render_style1_200_150.jpg',
    },
    {
        name: 'type#02',
        param: 'style2',
        src: '/assets/render_style2_200_150.jpg',
    },
    {
        name: 'type#03',
        param: 'style3',
        src: '/assets/render_style3_200_150.jpg',
    },
    {
        name: 'type#04',
        param: 'style4',
        src: '/assets/render_style4_200_150.jpg',
    },
    {
        name: 'type#05',
        param: 'style5',
        src: '/assets/render_style5_200_150.jpg',
    }];

export let render_1200_arr = [
    {
        name: 'default',
        param: 'default',
        src: '/assets/render_hack_1200_850.jpg',
    },
    {
        name: 'type#01',
        param: 'style1',
        src: '/assets/render_style1_1200_850.jpg',
    },
    {
        name: 'type#02',
        param: 'style2',
        src: '/assets/render_style2_1200_850.jpg',
    },
    {
        name: 'type#03',
        param: 'style3',
        src: '/assets/render_style3_1200_850.jpg',
    },
    {
        name: 'type#04',
        param: 'style4',
        src: '/assets/render_style4_1200_850.jpg',
    },
    {
        name: 'type#05',
        param: 'style5',
        src: '/assets/render_style5_1200_850.jpg',
    }];

export let render_custom_arr = [
    {
        name: 'default',
        param: 'default',
    },
    {
        name: 'type#01',
        param: 'style1',
    },
    {
        name: 'type#02',
        param: 'style2',
    },
    {
        name: 'type#03',
        param: 'style3',
    },
    {
        name: 'type#04',
        param: 'style4',
    },
    {
        name: 'type#05',
        param: 'style5',
    }];

export const colorPaletteArr = [
    { name: 'Auto', color: '#f6f6f6' },
    { name: 'Dataset', color: '#f6f6f6' },
    { name: 'Rose Beige', color: 'rgb(217,158,145)' },
    { name: 'Pale Ivory', color: 'rgb(204,143,114)' },
    { name: 'Pale Ivory', color: 'rgb(213,155,133)' },
    { name: 'Warm Ivory', color: 'rgb(186,145,125)' },
    { name: 'Sand', color: 'rgb(201,136,108)' },
    { name: 'Rose Beige', color: 'rgb(191,131,107)' },
    { name: 'Limestone', color: 'rgb(172,127,108)' },
    { name: 'Beige', color: 'rgb(183,126,99)' },
    { name: 'Sienna', color: 'rgb(171,110,91)' },
    { name: 'Amber', color: 'rgb(156,110,86)' },
    { name: 'Honey', color: 'rgb(103,65,52)' },
    { name: 'Band', color: 'rgb(82,52,50)' }
];

export const qualityArr = [
    {
        name: '2K',
        resolution: 'Basic',
        credits: 2
    },
    {
        name: '4K',
        resolution: 'High',
        credits: 4
    },];

export const topologyArr = [
    {
        name: 'Default',
        topology: 'USC',
        subscript: 'More options',
        credits: 0
    },
    {
        name: 'MetaHuman',
        topology: 'MetaHuman',
        subscript: 'Default 2K',
        credits: 2
    },
    {
        name: 'Daz3d',
        topology: 'Daz3d',
        subscript: 'Default 2K',
        credits: 2
    }
];

export const AdditionalArr = [
    {
        name: 'Rigged Body',
        option: 'AddBody',
        credits: 1,
        index: 0
    }, {
        name: 'Eye & Teeth',
        option: 'AddFacialComponent',
        credits: 1,
        index: 1
    }, {
        name: 'Expression BlendShapes',
        option: 'AddBS',
        credits: 1,
        index: 2
    }, {
        name: 'Back head Textures',
        option: 'AddBackHead',
        credits: 1,
        index: 3
    },
];

export const TwitterCopywriting = [
    "Game-ready 3D Avatars brought to life by @DeemosTech ChatAvatar's generative AI!🎮Create countless unique characters in seconds. Experience the power of generative AI with just prompts or images!",
    "Unleash your creativity with @DeemosTech ChatAvatar's generative AI!🎨Bring your ideas to life with Prompts or Images and effortlessly create unique digital characters.",
    "Transform your imagination into reality with @DeemosTech ChatAvatar's generative AI!⭐Create a diverse array of game-ready 3D Avatars from Prompts or Images.",
    "Step into a world of possibilities with @DeemosTech ChatAvatar's generative AI!🚀Generate customizable 3D Avatars instantly from a single Prompt or Image. Embrace the future of character creation!",
    "Bring your dreams to life with @DeemosTech ChatAvatar's generative AI!⭐Effortlessly create personalized, game-ready 3D Avatars from Prompts or Images. Join the AI revolution in character creation!",
    "Unlock the magic of @DeemosTech ChatAvatar's generative AI with Prompts or Images!✨Watch your ideas come alive as stunning, game-ready 3D Avatars. Express your creativity with ChatAvatar!",
];

export const TwitterRodinwriting = [
    "Revolutionize your workflow with @DeemosTech's Rodin! 🚀 Create near-production-ready 3D assets in seconds, featuring quad faces and PBR textures. Transform your projects with the power of generative AI!",
    "Elevate your project with @DeemosTech's Rodin! 🎮 Instantly generate 3D assets that are almost production-ready, complete with quad faces and PBR textures. Experience the future of 3D asset creation!",
    "Unleash your potential with @DeemosTech's Rodin! 🌟 Effortlessly produce 3D assets that save tons of effort for any project, featuring quad faces and PBR textures. Elevate your creativity with generative AI!",
    "Discover the power of @DeemosTech's Rodin! ✨ Generate stunning, closest to production-ready 3D assets with quad faces and PBR textures in seconds. Transform your creative process today!",
    "Unlock new possibilities with @DeemosTech's Rodin! 🚀 Create top-tier 3D assets with quad faces and PBR textures instantly. Embrace the next level of generative AI!",
];

export const carouselTitle = [
    {
        maintitle: "Take off Glasses",
        subtitle: 'It will look weird otherwise,',
        subtitle2: 'believe us.'
    },
    {
        maintitle: "Tie Your Hair",
        subtitle: 'Make sure your face is not',
        subtitle2: 'covered with hair.'
    },
    {
        maintitle: "Good Lighting",
        subtitle: 'Avoid shadows on your face.',
        subtitle2: 'E.g.stand in front of a window'
    },
    {
        maintitle: "Look Straight",
        subtitle: 'Hold the smart phone at the level of',
        subtitle2: 'your head, not lower'
    },
];

export const extraPrompt = [
    ["White", "Black", "African", "Asian", "Indigenous", "Latino", "Eastern", "Middle Eastern", "Pacific Islander", "Arab"],
    ["young", "teenager", "adult", "elder", "10 year old", "20 year old", "40 year old"],
    ["male", "female"]
];

export const stylizedArr = [
    {
        name: 'DreamFace V2',
        param: {
            style: "default",
            type: "dreamface_new"
        },
        selection: false,
    },
    {
        name: 'HERO Style',
        param: {
            style: "us-comic",
            type: "dreamface_new"
        },
        selection: false,
        src: '/assets/text-generate-hero.png',
    },
    {
        name: 'Toonify Style',
        param: {
            style: "cartoon",
            type: "dreamface_new"
        },
        selection: false,
        src: '/assets/text-generate-cartoon.png'
    },
    {
        name: 'DreamFace V1',
        param: {
            style: "default",
            type: "dreamface_trivial"
        },
        selection: true
    },
    {
        name: 'quadratic',
        param: {
            style: "quadratic",
            type: "dreamface_trivial"
        },
        selection: false
    },
    {
        name: 'traditional',
        param: {
            style: "traditional",
            type: "dreamface_trivial"
        },
        selection: false
    }
];

export const sideColorArr = ['#4737FF', '#FF9737', '#D7FF37', '#3787FF', '#9B37FF', '#FFD337', '#FF3797', '#4a00e0', '#38ce3f'];

// export const freeBenefits = [
//     'Generate Avatars by Text',
//     '10 Private Models',
//     'Export Avatars for Private Use'
// ]

// export const creatorBenefits = [
//     'All benefits in Free Tier',
//     'Unlimited Private Models',
//     'Rodin: Fuse multiple images into a single 3D models',
//     "Rodin: Use another image as texture reference",
//     "Rodin: More Poly - Count options",
//     "Rodin: Geometry Redo: ×20; Material Redo: ×6"
// ]

// export const businessBenefits = [
//     'All Benefits in Creator Tier',
//     'ChatAvatar: Free Preview before payments',
//     'ChatAvatar: Export Avatars for commercial use',
//     'Rodin: 4K textures & High-Poly (100K) Export',
//     'Rodin: Geometry Redo: ×50; Material Redo: ×15',
// ]

// export const enterpriseBenefits = [
//     'Ready for massive production',
//     'Option for programmable interface via API Service',
//     'Option for private on-premise deployment',
//     'Option for customized module devlopment / fine-tuning',
//     'Custom asset adaptation for rigging, stylization, topology and so on',
// ]

export const RODINWEIGHTS = [
    [[1], [0.5, 0.5], [0.33, 0.33, 0.34], [0.25, 0.25, 0.25, 0.25], [0.2, 0.2, 0.2, 0.2, 0.2]],
    [[1], [0.6, 0.4], [0.43, 0.33, 0.24], [0.4, 0.3, 0.2, 0.1], [0.3, 0.25, 0.2, 0.15, 0.1]],
    [[1], [0.5, 0.5], [0.5, 0.25, 0.25], [0.5, 0.17, 0.17, 0.16], [0.5, 0.125, 0.125, 0.125, 0.125]]
];

export const RODIN_GEOMETRY_REDO_COUNT = {
    default: 10,
    Creator: 20,
    Business: 50
}

export const RODIN_MATERIAL_REDO_COUNT = {
    default: 2,
    Creator: 4,
    Business: 10
}

export const directionMap = { x: "W", y: "H", z: "L" }

export const SAMPLING_ARRAY = [512, 1024, 2048]

export const MODE_ARRAY = [
    {
        name: "Strict",
        params: true
    },
    {
        name: "Rough",
        params: false
    }]

